import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components/macro'
import tw from 'twin.macro'

import { Icon } from 'components/Icon'

type PlayVideoButtonProps = {
  isPlaying: boolean
  onPress: () => void
}

export const PlayVideoButton = memo(function ({ isPlaying, onPress }: PlayVideoButtonProps) {
  const { t } = useTranslation()

  return (
    <PlayButton
      as="button"
      onClick={onPress}
      icon={isPlaying ? 'video-pause' : 'video-play'}
      aria-label={t(`psChart.video.${isPlaying ? 'Pause' : 'Play'}`)}
    />
  )
})

const PlayButton = styled(Icon)`
  ${tw`relative transition rounded-sm cursor-pointer w-16 h-8 text-icon`}
  color: ${({ theme }) => theme.colors.gray.normal};
  background: ${({ theme }) => theme.colors.dark.dark1};

  ${({ theme }) => theme.notTouchScreen} {
    &:hover {
      color: ${({ theme }) => theme.colors.electro};
    }
  }
`
